// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1gK2B","name":"styles_name__1cy68","phone":"styles_phone__2k-Xq"};